import React from 'react'

const termas = () => {
  return (
    <div style={{fontSize: '10rem'}}>termas</div>
  )
}

export default termas